define.alias("shared/components/shared/credentials/basic-display-status/upgrade", "calendar/components/shared/credentials/basic-display-status/upgrade");